import { z } from "zod";
import { DesignElementBase } from "./base";
import { FigmaFileStructureNode, FigmaFileStructureStatistics } from "./data/figma-file-structure";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";

export const FigmaFileStructureOrigin = z.object({
  sourceId: z.string(),
  fileId: z.string().optional(),
});

export const FigmaFileStructureData = z.object({
  rootNode: FigmaFileStructureNode,
  assetsInFile: FigmaFileStructureStatistics,
});

export const FigmaFileStructure = DesignElementBase.extend({
  origin: FigmaFileStructureOrigin,
  data: FigmaFileStructureData,
});

export type FigmaFileStructureOrigin = z.infer<typeof FigmaFileStructureOrigin>;
export type FigmaFileStructureData = z.infer<typeof FigmaFileStructureData>;
export type FigmaFileStructure = z.infer<typeof FigmaFileStructure>;

export type CreateFigmaFileStructure = DbCreateInputOmit<FigmaFileStructure>;
export type UpdateFigmaFileStructure = OmitStrict<DbUpdate<FigmaFileStructure>, "designSystemVersionId">;

export type FigmaFileStructureDiff = {
  toCreate: CreateFigmaFileStructure[];
  toUpdate: UpdateFigmaFileStructure[];
};

export function traverseStructure(node: FigmaFileStructureNode, action: (node: FigmaFileStructureNode) => void) {
  action(node);

  for (const child of node.children) {
    traverseStructure(child, action);
  }
}
